// Generated by KlangScriptProcessor, DO NOT EDIT
@file:Suppress("UNCHECKED_CAST", "UNUSED_PARAMETER", "UnusedImport")

package io.peekandpoke.klang.script.generated

import io.peekandpoke.klang.script.KlangScriptLibrary
import io.peekandpoke.klang.script.annotations.KlangScope
import io.peekandpoke.klang.script.ast.CallInfo
import io.peekandpoke.klang.script.builder.*
import io.peekandpoke.klang.script.runtime.*
import io.peekandpoke.klang.script.types.*

import io.peekandpoke.klang.audio_bridge.KatalystDsl
import io.peekandpoke.klang.script.runtime.ObjectValue
import io.peekandpoke.klang.script.runtime.StringValue
import io.peekandpoke.klang.script.stdlib.IgnitorSlotLike
import io.peekandpoke.klang.script.stdlib.KatalystSlotLike
import io.peekandpoke.klang.sprudel.SprudelPattern
import io.peekandpoke.klang.sprudel.lang.PatternLike
import io.peekandpoke.klang.sprudel.lang.PatternMapperFn
import io.peekandpoke.klang.sprudel.lang.PatternMapperProvider
import io.peekandpoke.klang.sprudel.lang.abs
import io.peekandpoke.klang.sprudel.lang.accelerate
import io.peekandpoke.klang.sprudel.lang.add
import io.peekandpoke.klang.sprudel.lang.adsr
import io.peekandpoke.klang.sprudel.lang.adsrCurves
import io.peekandpoke.klang.sprudel.lang.adsrOff
import io.peekandpoke.klang.sprudel.lang.adsrOn
import io.peekandpoke.klang.sprudel.lang.almostAlways
import io.peekandpoke.klang.sprudel.lang.almostNever
import io.peekandpoke.klang.sprudel.lang.always
import io.peekandpoke.klang.sprudel.lang.analog
import io.peekandpoke.klang.sprudel.lang.and
import io.peekandpoke.klang.sprudel.lang.apply
import io.peekandpoke.klang.sprudel.lang.applyN
import io.peekandpoke.klang.sprudel.lang.arrange
import io.peekandpoke.klang.sprudel.lang.bandpass
import io.peekandpoke.klang.sprudel.lang.bank
import io.peekandpoke.klang.sprudel.lang.beatRate
import io.peekandpoke.klang.sprudel.lang.beats
import io.peekandpoke.klang.sprudel.lang.begin
import io.peekandpoke.klang.sprudel.lang.berlin
import io.peekandpoke.klang.sprudel.lang.binary
import io.peekandpoke.klang.sprudel.lang.binaryL
import io.peekandpoke.klang.sprudel.lang.binaryN
import io.peekandpoke.klang.sprudel.lang.binaryNL
import io.peekandpoke.klang.sprudel.lang.bitAnd
import io.peekandpoke.klang.sprudel.lang.bitOr
import io.peekandpoke.klang.sprudel.lang.bitShl
import io.peekandpoke.klang.sprudel.lang.bitShr
import io.peekandpoke.klang.sprudel.lang.bitXor
import io.peekandpoke.klang.sprudel.lang.bite
import io.peekandpoke.klang.sprudel.lang.bjork
import io.peekandpoke.klang.sprudel.lang.body
import io.peekandpoke.klang.sprudel.lang.bpf
import io.peekandpoke.klang.sprudel.lang.bpfCurves
import io.peekandpoke.klang.sprudel.lang.bpm
import io.peekandpoke.klang.sprudel.lang.brak
import io.peekandpoke.klang.sprudel.lang.brand
import io.peekandpoke.klang.sprudel.lang.brandBy
import io.peekandpoke.klang.sprudel.lang.bypass
import io.peekandpoke.klang.sprudel.lang.cat
import io.peekandpoke.klang.sprudel.lang.ceil
import io.peekandpoke.klang.sprudel.lang.choose
import io.peekandpoke.klang.sprudel.lang.chooseCycles
import io.peekandpoke.klang.sprudel.lang.chooseIn
import io.peekandpoke.klang.sprudel.lang.chooseInWith
import io.peekandpoke.klang.sprudel.lang.chooseOut
import io.peekandpoke.klang.sprudel.lang.chooseWith
import io.peekandpoke.klang.sprudel.lang.chord
import io.peekandpoke.klang.sprudel.lang.chunk
import io.peekandpoke.klang.sprudel.lang.chunkBack
import io.peekandpoke.klang.sprudel.lang.chunkBackInto
import io.peekandpoke.klang.sprudel.lang.chunkInto
import io.peekandpoke.klang.sprudel.lang.chunkback
import io.peekandpoke.klang.sprudel.lang.chunkbackinto
import io.peekandpoke.klang.sprudel.lang.chunkinto
import io.peekandpoke.klang.sprudel.lang.clamp
import io.peekandpoke.klang.sprudel.lang.clip
import io.peekandpoke.klang.sprudel.lang.coarse
import io.peekandpoke.klang.sprudel.lang.comp
import io.peekandpoke.klang.sprudel.lang.compress
import io.peekandpoke.klang.sprudel.lang.compressor
import io.peekandpoke.klang.sprudel.lang.cosine
import io.peekandpoke.klang.sprudel.lang.cps
import io.peekandpoke.klang.sprudel.lang.crush
import io.peekandpoke.klang.sprudel.lang.cull
import io.peekandpoke.klang.sprudel.lang.cut
import io.peekandpoke.klang.sprudel.lang.cylinder
import io.peekandpoke.klang.sprudel.lang.d
import io.peekandpoke.klang.sprudel.lang.degrade
import io.peekandpoke.klang.sprudel.lang.degradeBy
import io.peekandpoke.klang.sprudel.lang.degradeByWith
import io.peekandpoke.klang.sprudel.lang.delay
import io.peekandpoke.klang.sprudel.lang.density
import io.peekandpoke.klang.sprudel.lang.densityGap
import io.peekandpoke.klang.sprudel.lang.distort
import io.peekandpoke.klang.sprudel.lang.div
import io.peekandpoke.klang.sprudel.lang.drop
import io.peekandpoke.klang.sprudel.lang.duck
import io.peekandpoke.klang.sprudel.lang.duty
import io.peekandpoke.klang.sprudel.lang.early
import io.peekandpoke.klang.sprudel.lang.earlyInCycle
import io.peekandpoke.klang.sprudel.lang.echo
import io.peekandpoke.klang.sprudel.lang.echoWith
import io.peekandpoke.klang.sprudel.lang.echowith
import io.peekandpoke.klang.sprudel.lang.eish
import io.peekandpoke.klang.sprudel.lang.end
import io.peekandpoke.klang.sprudel.lang.eq
import io.peekandpoke.klang.sprudel.lang.eqt
import io.peekandpoke.klang.sprudel.lang.euclid
import io.peekandpoke.klang.sprudel.lang.euclidLegato
import io.peekandpoke.klang.sprudel.lang.euclidLegatoRot
import io.peekandpoke.klang.sprudel.lang.euclidRot
import io.peekandpoke.klang.sprudel.lang.euclidish
import io.peekandpoke.klang.sprudel.lang.euclidrot
import io.peekandpoke.klang.sprudel.lang.every
import io.peekandpoke.klang.sprudel.lang.extend
import io.peekandpoke.klang.sprudel.lang.fast
import io.peekandpoke.klang.sprudel.lang.fastChunk
import io.peekandpoke.klang.sprudel.lang.fastGap
import io.peekandpoke.klang.sprudel.lang.fastcat
import io.peekandpoke.klang.sprudel.lang.fastchunk
import io.peekandpoke.klang.sprudel.lang.filterWhen
import io.peekandpoke.klang.sprudel.lang.firstOf
import io.peekandpoke.klang.sprudel.lang.flipSign
import io.peekandpoke.klang.sprudel.lang.floor
import io.peekandpoke.klang.sprudel.lang.fm
import io.peekandpoke.klang.sprudel.lang.focus
import io.peekandpoke.klang.sprudel.lang.freq
import io.peekandpoke.klang.sprudel.lang.gain
import io.peekandpoke.klang.sprudel.lang.gap
import io.peekandpoke.klang.sprudel.lang.gt
import io.peekandpoke.klang.sprudel.lang.gte
import io.peekandpoke.klang.sprudel.lang.highpass
import io.peekandpoke.klang.sprudel.lang.hpf
import io.peekandpoke.klang.sprudel.lang.hpfCurves
import io.peekandpoke.klang.sprudel.lang.hurry
import io.peekandpoke.klang.sprudel.lang.hush
import io.peekandpoke.klang.sprudel.lang.ignitorParam
import io.peekandpoke.klang.sprudel.lang.ignp
import io.peekandpoke.klang.sprudel.lang.inhabit
import io.peekandpoke.klang.sprudel.lang.inhabitmod
import io.peekandpoke.klang.sprudel.lang.inside
import io.peekandpoke.klang.sprudel.lang.inv
import io.peekandpoke.klang.sprudel.lang.invert
import io.peekandpoke.klang.sprudel.lang.irand
import io.peekandpoke.klang.sprudel.lang.iter
import io.peekandpoke.klang.sprudel.lang.iterBack
import io.peekandpoke.klang.sprudel.lang.jux
import io.peekandpoke.klang.sprudel.lang.juxBy
import io.peekandpoke.klang.sprudel.lang.katalyst
import io.peekandpoke.klang.sprudel.lang.katalystParam
import io.peekandpoke.klang.sprudel.lang.katp
import io.peekandpoke.klang.sprudel.lang.lastOf
import io.peekandpoke.klang.sprudel.lang.late
import io.peekandpoke.klang.sprudel.lang.lateInCycle
import io.peekandpoke.klang.sprudel.lang.layer
import io.peekandpoke.klang.sprudel.lang.legato
import io.peekandpoke.klang.sprudel.lang.linger
import io.peekandpoke.klang.sprudel.lang.log2
import io.peekandpoke.klang.sprudel.lang.loop
import io.peekandpoke.klang.sprudel.lang.loopAt
import io.peekandpoke.klang.sprudel.lang.loopAtCps
import io.peekandpoke.klang.sprudel.lang.loopatcps
import io.peekandpoke.klang.sprudel.lang.lowpass
import io.peekandpoke.klang.sprudel.lang.lpf
import io.peekandpoke.klang.sprudel.lang.lpfCurves
import io.peekandpoke.klang.sprudel.lang.lt
import io.peekandpoke.klang.sprudel.lang.lte
import io.peekandpoke.klang.sprudel.lang.mask
import io.peekandpoke.klang.sprudel.lang.maskAll
import io.peekandpoke.klang.sprudel.lang.master
import io.peekandpoke.klang.sprudel.lang.max
import io.peekandpoke.klang.sprudel.lang.merge
import io.peekandpoke.klang.sprudel.lang.min
import io.peekandpoke.klang.sprudel.lang.mini
import io.peekandpoke.klang.sprudel.lang.mod
import io.peekandpoke.klang.sprudel.lang.morse
import io.peekandpoke.klang.sprudel.lang.mul
import io.peekandpoke.klang.sprudel.lang.mute
import io.peekandpoke.klang.sprudel.lang.n
import io.peekandpoke.klang.sprudel.lang.ne
import io.peekandpoke.klang.sprudel.lang.net
import io.peekandpoke.klang.sprudel.lang.never
import io.peekandpoke.klang.sprudel.lang.noCull
import io.peekandpoke.klang.sprudel.lang.not
import io.peekandpoke.klang.sprudel.lang.notch
import io.peekandpoke.klang.sprudel.lang.notchCurves
import io.peekandpoke.klang.sprudel.lang.note
import io.peekandpoke.klang.sprudel.lang.nothing
import io.peekandpoke.klang.sprudel.lang.o
import io.peekandpoke.klang.sprudel.lang.off
import io.peekandpoke.klang.sprudel.lang.often
import io.peekandpoke.klang.sprudel.lang.oneMinusValue
import io.peekandpoke.klang.sprudel.lang.onepole
import io.peekandpoke.klang.sprudel.lang.or
import io.peekandpoke.klang.sprudel.lang.orbit
import io.peekandpoke.klang.sprudel.lang.outside
import io.peekandpoke.klang.sprudel.lang.pace
import io.peekandpoke.klang.sprudel.lang.palindrome
import io.peekandpoke.klang.sprudel.lang.pan
import io.peekandpoke.klang.sprudel.lang.penv
import io.peekandpoke.klang.sprudel.lang.penvCurves
import io.peekandpoke.klang.sprudel.lang.perlin
import io.peekandpoke.klang.sprudel.lang.phaser
import io.peekandpoke.klang.sprudel.lang.pick
import io.peekandpoke.klang.sprudel.lang.pickF
import io.peekandpoke.klang.sprudel.lang.pickOut
import io.peekandpoke.klang.sprudel.lang.pickReset
import io.peekandpoke.klang.sprudel.lang.pickRestart
import io.peekandpoke.klang.sprudel.lang.pickSqueeze
import io.peekandpoke.klang.sprudel.lang.pickmod
import io.peekandpoke.klang.sprudel.lang.pickmodF
import io.peekandpoke.klang.sprudel.lang.pickmodOut
import io.peekandpoke.klang.sprudel.lang.pickmodReset
import io.peekandpoke.klang.sprudel.lang.pickmodRestart
import io.peekandpoke.klang.sprudel.lang.pickmodSqueeze
import io.peekandpoke.klang.sprudel.lang.ply
import io.peekandpoke.klang.sprudel.lang.plyForEach
import io.peekandpoke.klang.sprudel.lang.plyWith
import io.peekandpoke.klang.sprudel.lang.plyforeach
import io.peekandpoke.klang.sprudel.lang.plywith
import io.peekandpoke.klang.sprudel.lang.polymeter
import io.peekandpoke.klang.sprudel.lang.polymeterSteps
import io.peekandpoke.klang.sprudel.lang.polyrhythm
import io.peekandpoke.klang.sprudel.lang.pow
import io.peekandpoke.klang.sprudel.lang.pregain
import io.peekandpoke.klang.sprudel.lang.press
import io.peekandpoke.klang.sprudel.lang.pressBy
import io.peekandpoke.klang.sprudel.lang.pure
import io.peekandpoke.klang.sprudel.lang.rand
import io.peekandpoke.klang.sprudel.lang.randCycle
import io.peekandpoke.klang.sprudel.lang.randcat
import io.peekandpoke.klang.sprudel.lang.randrun
import io.peekandpoke.klang.sprudel.lang.range
import io.peekandpoke.klang.sprudel.lang.rangex
import io.peekandpoke.klang.sprudel.lang.rarely
import io.peekandpoke.klang.sprudel.lang.ratio
import io.peekandpoke.klang.sprudel.lang.repeat
import io.peekandpoke.klang.sprudel.lang.repeatCycles
import io.peekandpoke.klang.sprudel.lang.rest
import io.peekandpoke.klang.sprudel.lang.rev
import io.peekandpoke.klang.sprudel.lang.reverb
import io.peekandpoke.klang.sprudel.lang.revv
import io.peekandpoke.klang.sprudel.lang.rib
import io.peekandpoke.klang.sprudel.lang.ribbon
import io.peekandpoke.klang.sprudel.lang.rootNotes
import io.peekandpoke.klang.sprudel.lang.round
import io.peekandpoke.klang.sprudel.lang.rpm
import io.peekandpoke.klang.sprudel.lang.run
import io.peekandpoke.klang.sprudel.lang.s
import io.peekandpoke.klang.sprudel.lang.s_cat
import io.peekandpoke.klang.sprudel.lang.saw
import io.peekandpoke.klang.sprudel.lang.scale
import io.peekandpoke.klang.sprudel.lang.scaleTranspose
import io.peekandpoke.klang.sprudel.lang.scramble
import io.peekandpoke.klang.sprudel.lang.seed
import io.peekandpoke.klang.sprudel.lang.seg
import io.peekandpoke.klang.sprudel.lang.segment
import io.peekandpoke.klang.sprudel.lang.seq
import io.peekandpoke.klang.sprudel.lang.sequenceP
import io.peekandpoke.klang.sprudel.lang.shuffle
import io.peekandpoke.klang.sprudel.lang.signal
import io.peekandpoke.klang.sprudel.lang.silence
import io.peekandpoke.klang.sprudel.lang.sine
import io.peekandpoke.klang.sprudel.lang.sineOfDay
import io.peekandpoke.klang.sprudel.lang.sineOfNight
import io.peekandpoke.klang.sprudel.lang.slice
import io.peekandpoke.klang.sprudel.lang.slow
import io.peekandpoke.klang.sprudel.lang.slowChunk
import io.peekandpoke.klang.sprudel.lang.slowcat
import io.peekandpoke.klang.sprudel.lang.slowcatPrime
import io.peekandpoke.klang.sprudel.lang.slowchunk
import io.peekandpoke.klang.sprudel.lang.sndBrown
import io.peekandpoke.klang.sprudel.lang.sndCrackle
import io.peekandpoke.klang.sprudel.lang.sndDust
import io.peekandpoke.klang.sprudel.lang.sndNoise
import io.peekandpoke.klang.sprudel.lang.sndPink
import io.peekandpoke.klang.sprudel.lang.sndPluck
import io.peekandpoke.klang.sprudel.lang.sndPulze
import io.peekandpoke.klang.sprudel.lang.sndRamp
import io.peekandpoke.klang.sprudel.lang.sndSaw
import io.peekandpoke.klang.sprudel.lang.sndSine
import io.peekandpoke.klang.sprudel.lang.sndSquare
import io.peekandpoke.klang.sprudel.lang.sndSuperPluck
import io.peekandpoke.klang.sprudel.lang.sndSuperRamp
import io.peekandpoke.klang.sprudel.lang.sndSuperSaw
import io.peekandpoke.klang.sprudel.lang.sndSuperSine
import io.peekandpoke.klang.sprudel.lang.sndSuperSquare
import io.peekandpoke.klang.sprudel.lang.sndSuperTri
import io.peekandpoke.klang.sprudel.lang.sndTri
import io.peekandpoke.klang.sprudel.lang.sndZamp
import io.peekandpoke.klang.sprudel.lang.solo
import io.peekandpoke.klang.sprudel.lang.someCycles
import io.peekandpoke.klang.sprudel.lang.someCyclesBy
import io.peekandpoke.klang.sprudel.lang.sometimes
import io.peekandpoke.klang.sprudel.lang.sometimesBy
import io.peekandpoke.klang.sprudel.lang.sound
import io.peekandpoke.klang.sprudel.lang.speed
import io.peekandpoke.klang.sprudel.lang.splice
import io.peekandpoke.klang.sprudel.lang.square
import io.peekandpoke.klang.sprudel.lang.squeeze
import io.peekandpoke.klang.sprudel.lang.stack
import io.peekandpoke.klang.sprudel.lang.stackBy
import io.peekandpoke.klang.sprudel.lang.stackCentre
import io.peekandpoke.klang.sprudel.lang.stackLeft
import io.peekandpoke.klang.sprudel.lang.stackRight
import io.peekandpoke.klang.sprudel.lang.steady
import io.peekandpoke.klang.sprudel.lang.stepcat
import io.peekandpoke.klang.sprudel.lang.steps
import io.peekandpoke.klang.sprudel.lang.stretchBy
import io.peekandpoke.klang.sprudel.lang.struct
import io.peekandpoke.klang.sprudel.lang.structAll
import io.peekandpoke.klang.sprudel.lang.stut
import io.peekandpoke.klang.sprudel.lang.stutWith
import io.peekandpoke.klang.sprudel.lang.stutwith
import io.peekandpoke.klang.sprudel.lang.sub
import io.peekandpoke.klang.sprudel.lang.superimpose
import io.peekandpoke.klang.sprudel.lang.swing
import io.peekandpoke.klang.sprudel.lang.swingBy
import io.peekandpoke.klang.sprudel.lang.tag
import io.peekandpoke.klang.sprudel.lang.take
import io.peekandpoke.klang.sprudel.lang.time
import io.peekandpoke.klang.sprudel.lang.timeCat
import io.peekandpoke.klang.sprudel.lang.timeLoop
import io.peekandpoke.klang.sprudel.lang.timeOfDay
import io.peekandpoke.klang.sprudel.lang.timeOfNight
import io.peekandpoke.klang.sprudel.lang.timecat
import io.peekandpoke.klang.sprudel.lang.transpose
import io.peekandpoke.klang.sprudel.lang.tremolo
import io.peekandpoke.klang.sprudel.lang.tri
import io.peekandpoke.klang.sprudel.lang.tweak
import io.peekandpoke.klang.sprudel.lang.tweaks
import io.peekandpoke.klang.sprudel.lang.undegrade
import io.peekandpoke.klang.sprudel.lang.undegradeBy
import io.peekandpoke.klang.sprudel.lang.undegradeByWith
import io.peekandpoke.klang.sprudel.lang.uni
import io.peekandpoke.klang.sprudel.lang.unison
import io.peekandpoke.klang.sprudel.lang.unit
import io.peekandpoke.klang.sprudel.lang.vel
import io.peekandpoke.klang.sprudel.lang.velocity
import io.peekandpoke.klang.sprudel.lang.vib
import io.peekandpoke.klang.sprudel.lang.vibrato
import io.peekandpoke.klang.sprudel.lang.voicing
import io.peekandpoke.klang.sprudel.lang.vowel
import io.peekandpoke.klang.sprudel.lang.wchoose
import io.peekandpoke.klang.sprudel.lang.wchooseCycles
import io.peekandpoke.klang.sprudel.lang.`when`
import io.peekandpoke.klang.sprudel.lang.withSeed
import io.peekandpoke.klang.sprudel.lang.within
import io.peekandpoke.klang.sprudel.lang.wrandcat
import io.peekandpoke.klang.sprudel.lang.zoom
import kotlin.Function1

internal fun KlangScriptExtensionBuilder.registerSprudelLangRandomChunk0() {

    // @Function on chooseWith
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("chooseWith") { args, callInfo -> chooseWith(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "chooseWith",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "chooseWith", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.chooseWith(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "chooseWith",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "chooseWith", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.chooseWith(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on chooseInWith
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("chooseInWith") { args, callInfo -> chooseInWith(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "chooseInWith",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "chooseInWith", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.chooseInWith(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "chooseInWith",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "chooseInWith", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.chooseInWith(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on choose
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("choose") { args, callInfo -> choose(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "choose",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "choose", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.choose(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "choose",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "choose", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.choose(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on chooseOut
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("chooseOut") { args, callInfo -> chooseOut(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "chooseOut",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "chooseOut", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.chooseOut(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "chooseOut",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "chooseOut", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.chooseOut(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on chooseIn
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("chooseIn") { args, callInfo -> chooseIn(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "chooseIn",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "chooseIn", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.chooseIn(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "chooseIn",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "chooseIn", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.chooseIn(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on chooseCycles
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("chooseCycles") { args, callInfo -> chooseCycles(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "chooseCycles",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "chooseCycles", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.chooseCycles(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "chooseCycles",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "chooseCycles", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.chooseCycles(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on randcat
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("randcat") { args, callInfo -> randcat(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "randcat",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "randcat", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.randcat(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "randcat",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "randcat", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.randcat(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on wchoose
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("wchoose") { args, callInfo -> wchoose(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "wchoose",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "wchoose", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.wchoose(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "wchoose",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "wchoose", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.wchoose(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on wchooseCycles
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("wchooseCycles") { args, callInfo -> wchooseCycles(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "wchooseCycles",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "wchooseCycles", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.wchooseCycles(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "wchooseCycles",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "wchooseCycles", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.wchooseCycles(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on wrandcat
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("wrandcat") { args, callInfo -> wrandcat(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "wrandcat",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "wrandcat", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.wrandcat(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "wrandcat",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "wrandcat", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.wrandcat(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "degradeBy",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "degradeBy", args = args, expected = 1, location = loc)
        val prob = convertArgToKotlin(fn = "degradeBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.degradeBy(prob = prob, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "degradeBy",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "degradeBy", args = args, expected = 1, location = loc)
        val prob = convertArgToKotlin(fn = "degradeBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.degradeBy(prob = prob, callInfo = callInfo))
    }

    // @Function on degradeBy
    registerFunctionWithSpecs(
        name = "degradeBy",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "degradeBy", args = args, expected = 1, location = loc)
        val prob = convertArgToKotlin(fn = "degradeBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(degradeBy(prob = prob, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "degradeBy",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "degradeBy", args = args, expected = 1, location = loc)
        val prob = convertArgToKotlin(fn = "degradeBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.degradeBy(prob = prob, callInfo = callInfo))
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangRandomChunk1() {

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "degrade",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.5) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "degrade", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.degrade(
                prob = if (args.size > 0) convertArgToKotlin(fn = "degrade", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any else 0.5,
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "degrade",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.5) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "degrade", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.degrade(
                prob = if (args.size > 0) convertArgToKotlin(fn = "degrade", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any else 0.5,
                callInfo = callInfo,
            )
        )
    }

    // @Function on degrade
    registerFunctionWithSpecs(
        name = "degrade",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.5) })
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "degrade", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            degrade(
                prob = if (args.size > 0) convertArgToKotlin(fn = "degrade", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any else 0.5,
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "degrade",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.5) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "degrade", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.degrade(
                prob = if (args.size > 0) convertArgToKotlin(fn = "degrade", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any else 0.5,
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "degradeByWith",
        paramSpecs = listOf(
            ParamSpec(name = "withPat", kotlinType = Any::class),
            ParamSpec(name = "prob", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "degradeByWith", args = args, expected = 2, location = loc)
        val withPat = convertArgToKotlin(fn = "degradeByWith", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val prob = convertArgToKotlin(fn = "degradeByWith", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.degradeByWith(withPat = withPat, prob = prob, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "degradeByWith",
        paramSpecs = listOf(
            ParamSpec(name = "withPat", kotlinType = Any::class),
            ParamSpec(name = "prob", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "degradeByWith", args = args, expected = 2, location = loc)
        val withPat = convertArgToKotlin(fn = "degradeByWith", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val prob = convertArgToKotlin(fn = "degradeByWith", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.degradeByWith(withPat = withPat, prob = prob, callInfo = callInfo))
    }

    // @Function on degradeByWith
    registerFunctionWithSpecs(
        name = "degradeByWith",
        paramSpecs = listOf(
            ParamSpec(name = "withPat", kotlinType = Any::class),
            ParamSpec(name = "prob", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "degradeByWith", args = args, expected = 2, location = loc)
        val withPat = convertArgToKotlin(fn = "degradeByWith", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val prob = convertArgToKotlin(fn = "degradeByWith", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(degradeByWith(withPat = withPat, prob = prob, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "degradeByWith",
        paramSpecs = listOf(
            ParamSpec(name = "withPat", kotlinType = Any::class),
            ParamSpec(name = "prob", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "degradeByWith", args = args, expected = 2, location = loc)
        val withPat = convertArgToKotlin(fn = "degradeByWith", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val prob = convertArgToKotlin(fn = "degradeByWith", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.degradeByWith(withPat = withPat, prob = prob, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "undegradeBy",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "undegradeBy", args = args, expected = 1, location = loc)
        val prob = convertArgToKotlin(fn = "undegradeBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.undegradeBy(prob = prob, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "undegradeBy",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "undegradeBy", args = args, expected = 1, location = loc)
        val prob = convertArgToKotlin(fn = "undegradeBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.undegradeBy(prob = prob, callInfo = callInfo))
    }

    // @Function on undegradeBy
    registerFunctionWithSpecs(
        name = "undegradeBy",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "undegradeBy", args = args, expected = 1, location = loc)
        val prob = convertArgToKotlin(fn = "undegradeBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(undegradeBy(prob = prob, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "undegradeBy",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "undegradeBy", args = args, expected = 1, location = loc)
        val prob = convertArgToKotlin(fn = "undegradeBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.undegradeBy(prob = prob, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "undegradeByWith",
        paramSpecs = listOf(
            ParamSpec(name = "withPat", kotlinType = Any::class),
            ParamSpec(name = "prob", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "undegradeByWith", args = args, expected = 2, location = loc)
        val withPat = convertArgToKotlin(fn = "undegradeByWith", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val prob = convertArgToKotlin(fn = "undegradeByWith", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.undegradeByWith(withPat = withPat, prob = prob, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "undegradeByWith",
        paramSpecs = listOf(
            ParamSpec(name = "withPat", kotlinType = Any::class),
            ParamSpec(name = "prob", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "undegradeByWith", args = args, expected = 2, location = loc)
        val withPat = convertArgToKotlin(fn = "undegradeByWith", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val prob = convertArgToKotlin(fn = "undegradeByWith", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.undegradeByWith(withPat = withPat, prob = prob, callInfo = callInfo))
    }

    // @Function on undegradeByWith
    registerFunctionWithSpecs(
        name = "undegradeByWith",
        paramSpecs = listOf(
            ParamSpec(name = "withPat", kotlinType = Any::class),
            ParamSpec(name = "prob", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "undegradeByWith", args = args, expected = 2, location = loc)
        val withPat = convertArgToKotlin(fn = "undegradeByWith", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val prob = convertArgToKotlin(fn = "undegradeByWith", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(undegradeByWith(withPat = withPat, prob = prob, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "undegradeByWith",
        paramSpecs = listOf(
            ParamSpec(name = "withPat", kotlinType = Any::class),
            ParamSpec(name = "prob", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "undegradeByWith", args = args, expected = 2, location = loc)
        val withPat = convertArgToKotlin(fn = "undegradeByWith", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val prob = convertArgToKotlin(fn = "undegradeByWith", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.undegradeByWith(withPat = withPat, prob = prob, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "undegrade",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkNoArgs(fn = "undegrade", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.undegrade(callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "undegrade",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkNoArgs(fn = "undegrade", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.undegrade(callInfo = callInfo))
    }

    // @Function on undegrade
    registerFunctionWithSpecs(
        name = "undegrade",
        paramSpecs = emptyList(),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkNoArgs(fn = "undegrade", args = args, location = loc)
        wrapAsRuntimeValue(undegrade(callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "undegrade",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkNoArgs(fn = "undegrade", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.undegrade(callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "shuffle",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "shuffle", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "shuffle", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.shuffle(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "shuffle",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "shuffle", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "shuffle", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.shuffle(n = n, callInfo = callInfo))
    }

    // @Function on shuffle
    registerFunctionWithSpecs(
        name = "shuffle",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "shuffle", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "shuffle", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(shuffle(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "shuffle",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "shuffle", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "shuffle", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.shuffle(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "scramble",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "scramble", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "scramble", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scramble(n = n, callInfo = callInfo))
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangRandomChunk2() {

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "scramble",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "scramble", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "scramble", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scramble(n = n, callInfo = callInfo))
    }

    // @Function on scramble
    registerFunctionWithSpecs(
        name = "scramble",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "scramble", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "scramble", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(scramble(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "scramble",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "scramble", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "scramble", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scramble(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sometimesBy",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class),
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sometimesBy", args = args, expected = 2, location = loc)
        val prob = convertArgToKotlin(fn = "sometimesBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val mapper = convertArgToKotlin(fn = "sometimesBy", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.sometimesBy(prob = prob, mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sometimesBy",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class),
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sometimesBy", args = args, expected = 2, location = loc)
        val prob = convertArgToKotlin(fn = "sometimesBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val mapper = convertArgToKotlin(fn = "sometimesBy", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.sometimesBy(prob = prob, mapper = mapper, callInfo = callInfo))
    }

    // @Function on sometimesBy
    registerFunctionWithSpecs(
        name = "sometimesBy",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class),
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sometimesBy", args = args, expected = 2, location = loc)
        val prob = convertArgToKotlin(fn = "sometimesBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val mapper = convertArgToKotlin(fn = "sometimesBy", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(sometimesBy(prob = prob, mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sometimesBy",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class),
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sometimesBy", args = args, expected = 2, location = loc)
        val prob = convertArgToKotlin(fn = "sometimesBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val mapper = convertArgToKotlin(fn = "sometimesBy", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.sometimesBy(prob = prob, mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sometimes",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sometimes", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "sometimes", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.sometimes(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sometimes",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sometimes", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "sometimes", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.sometimes(mapper = mapper, callInfo = callInfo))
    }

    // @Function on sometimes
    registerFunctionWithSpecs(
        name = "sometimes",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sometimes", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "sometimes", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(sometimes(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sometimes",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sometimes", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "sometimes", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.sometimes(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "often",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "often", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "often", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.often(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "often",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "often", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "often", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.often(mapper = mapper, callInfo = callInfo))
    }

    // @Function on often
    registerFunctionWithSpecs(
        name = "often",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "often", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "often", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(often(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "often",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "often", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "often", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.often(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "rarely",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "rarely", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "rarely", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.rarely(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "rarely",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "rarely", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "rarely", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.rarely(mapper = mapper, callInfo = callInfo))
    }

    // @Function on rarely
    registerFunctionWithSpecs(
        name = "rarely",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "rarely", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "rarely", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(rarely(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "rarely",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "rarely", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "rarely", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.rarely(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "almostNever",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "almostNever", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "almostNever", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.almostNever(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "almostNever",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "almostNever", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "almostNever", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.almostNever(mapper = mapper, callInfo = callInfo))
    }

    // @Function on almostNever
    registerFunctionWithSpecs(
        name = "almostNever",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "almostNever", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "almostNever", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(almostNever(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "almostNever",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "almostNever", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "almostNever", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.almostNever(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "almostAlways",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "almostAlways", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "almostAlways", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.almostAlways(mapper = mapper, callInfo = callInfo))
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangRandomChunk3() {

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "almostAlways",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "almostAlways", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "almostAlways", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.almostAlways(mapper = mapper, callInfo = callInfo))
    }

    // @Function on almostAlways
    registerFunctionWithSpecs(
        name = "almostAlways",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "almostAlways", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "almostAlways", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(almostAlways(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "almostAlways",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "almostAlways", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "almostAlways", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.almostAlways(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "never",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "never", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "never", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.never(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "never",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "never", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "never", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.never(mapper = mapper, callInfo = callInfo))
    }

    // @Function on never
    registerFunctionWithSpecs(
        name = "never",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "never", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "never", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(never(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "never",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "never", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "never", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.never(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "always",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "always", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "always", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.always(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "always",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "always", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "always", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.always(mapper = mapper, callInfo = callInfo))
    }

    // @Function on always
    registerFunctionWithSpecs(
        name = "always",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "always", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "always", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(always(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "always",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "always", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "always", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.always(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "someCyclesBy",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class),
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "someCyclesBy", args = args, expected = 2, location = loc)
        val prob = convertArgToKotlin(fn = "someCyclesBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val mapper = convertArgToKotlin(fn = "someCyclesBy", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.someCyclesBy(prob = prob, mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "someCyclesBy",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class),
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "someCyclesBy", args = args, expected = 2, location = loc)
        val prob = convertArgToKotlin(fn = "someCyclesBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val mapper = convertArgToKotlin(fn = "someCyclesBy", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.someCyclesBy(prob = prob, mapper = mapper, callInfo = callInfo))
    }

    // @Function on someCyclesBy
    registerFunctionWithSpecs(
        name = "someCyclesBy",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class),
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "someCyclesBy", args = args, expected = 2, location = loc)
        val prob = convertArgToKotlin(fn = "someCyclesBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val mapper = convertArgToKotlin(fn = "someCyclesBy", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(someCyclesBy(prob = prob, mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "someCyclesBy",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class),
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "someCyclesBy", args = args, expected = 2, location = loc)
        val prob = convertArgToKotlin(fn = "someCyclesBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val mapper = convertArgToKotlin(fn = "someCyclesBy", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.someCyclesBy(prob = prob, mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "someCycles",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "someCycles", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "someCycles", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.someCycles(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "someCycles",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "someCycles", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "someCycles", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.someCycles(mapper = mapper, callInfo = callInfo))
    }

    // @Function on someCycles
    registerFunctionWithSpecs(
        name = "someCycles",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "someCycles", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "someCycles", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(someCycles(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "someCycles",
        paramSpecs = listOf(
            ParamSpec(name = "mapper", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "someCycles", args = args, expected = 1, location = loc)
        val mapper = convertArgToKotlin(fn = "someCycles", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.someCycles(mapper = mapper, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "seed",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "seed", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "seed", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.seed(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "seed",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "seed", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "seed", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.seed(n = n, callInfo = callInfo))
    }

    // @Function on seed
    registerFunctionWithSpecs(
        name = "seed",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "seed", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "seed", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(seed(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "seed",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "seed", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "seed", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.seed(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "withSeed",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "withSeed", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "withSeed", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.withSeed(n = n, callInfo = callInfo))
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangRandomChunk4() {

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "withSeed",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "withSeed", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "withSeed", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.withSeed(n = n, callInfo = callInfo))
    }

    // @Function on withSeed
    registerFunctionWithSpecs(
        name = "withSeed",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "withSeed", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "withSeed", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(withSeed(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "withSeed",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "withSeed", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "withSeed", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.withSeed(n = n, callInfo = callInfo))
    }

    // @Object("rand") on rand
    registerObject("rand", rand) {
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "__invoke__",
            paramSpecs = listOf(
                ParamSpec(name = "from", kotlinType = Number::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "to", kotlinType = Number::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            val callInfo = callInfoOf(receiver, args, loc)
            checkArgsSize(fn = "rand", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                rand.invoke(
                    from = optArg(args, 0, Number::class, loc),
                    to = optArg(args, 1, Number::class, loc),
                    callInfo = callInfo,
                )
            )
        }
    }

    // @Property on randCycle
    registerObject("randCycle", randCycle)

    // @Function on brandBy
    registerFunctionWithSpecs(
        name = "brandBy",
        paramSpecs = listOf(
            ParamSpec(name = "prob", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "brandBy", args = args, expected = 1, location = loc)
        val prob = convertArgToKotlin(fn = "brandBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(brandBy(prob = prob, callInfo = callInfo))
    }

    // @Property on brand
    registerObject("brand", brand)

    // @Function on irand
    registerFunctionWithSpecs(
        name = "irand",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "irand", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "irand", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(irand(n = n, callInfo = callInfo))
    }

    // @Function on randrun
    registerFunctionWithSpecs(
        name = "randrun",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "randrun", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "randrun", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(randrun(n = n, callInfo = callInfo))
    }
}

